import { useEffect, useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { api } from "@/lib/api";

const MAP = {
  online: { dot: "🟢", label: "ONLINE", cls: "text-emerald-400", border: "border-emerald-500/30" },
  maintenance: { dot: "🟡", label: "MANUTENÇÃO", cls: "text-amber-400", border: "border-amber-500/30" },
  instability: { dot: "🔴", label: "INSTABILIDADE", cls: "text-red-400", border: "border-red-500/30" },
};

export default function StatusPage() {
  const [status, setStatus] = useState([]);
  useEffect(() => { api.get("/status").then((r) => setStatus(r.data)); }, []);
  const fmt = (iso) => { try { return new Date(iso).toLocaleString("pt-BR"); } catch { return "-"; } };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Status" title="Status dos Serviços"
          subtitle="Acompanhe em tempo real o funcionamento dos nossos serviços." />
        <div className="grid gap-4 sm:grid-cols-2">
          {status.map((s) => {
            const m = MAP[s.status] || MAP.online;
            return (
              <div key={s.id} data-testid={`status-card-${s.id}`} className={`ci-card p-6 ${m.border}`}>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg">{s.name}</h3>
                  <span className={`text-xs font-bold ${m.cls}`}>{m.dot} {m.label}</span>
                </div>
                <p className="text-sm text-gray-400">{s.message}</p>
                <div className="text-xs text-gray-600 mt-3">Última atualização: {fmt(s.updated_at)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
